import { Injectable, inject } from '@angular/core';
import { lastValueFrom, Subject } from 'rxjs';
import { AppService } from '@src/api';
import { logger } from '@src/utils';
import { AlertService } from '@src/core/services';
import { loadScriptByUrl } from '@src/utils';

import { CAPTCHA_CONFIG } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class CaptchaService {
  private readonly appService = inject(AppService);
  private readonly alertService = inject(AlertService);

  captchaValid$ = new Subject<boolean>();
  challengeVisible$ = new Subject<boolean>();
  captchaError$ = new Subject<string | null>();

  private smartCaptcha: any; // TODO: fix type
  private captchaId?: number;

  constructor() {
    // <script src="https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=onloadFunction" defer></script>
    // INFO: false т.к. defer
    loadScriptByUrl(CAPTCHA_CONFIG.scriptUrl, false).then(() => {
      this.captchaError$.subscribe(err => {
        if (err) {
          this.alertService.error(`Captcha error: ${err}`);
        }
      });
    });
  }

  initCaptcha() {
    this.smartCaptcha = window.smartCaptcha;
    this.captchaId = this.getCaptchaId(); // INFO: id равен 0

    if (this.captchaId !== undefined) {
      this.smartCaptcha.subscribe(this.captchaId, 'challenge-visible', () => this.challengeVisible$.next(true));
      this.smartCaptcha.subscribe(this.captchaId, 'challenge-hidden', () => this.challengeVisible$.next(false));
      this.smartCaptcha.subscribe(this.captchaId, 'network-error', () => {
        this.captchaError$.next('Network error');
      });
      this.smartCaptcha.subscribe(this.captchaId, 'javascript-error', (error: any) => {
        this.captchaError$.next('Javascript error');
        logger(error);
      });

      this.smartCaptcha.execute(this.captchaId);
    } else {
      this.captchaValid$.next(false);
    }
  }

  private checkCaptcha(token: string) {
    if (typeof token !== 'string' || token.length === 0) {
      logger('Captcha - Некорректный токен - token:', token);
      this.captchaValid$?.next(false);
      return;
    }

    lastValueFrom(this.appService.checkCapture({ token })).then(res => {
      this.captchaValid$?.next(!!res.isCorrect);
    });
  }

  private getCaptchaId() {
    if (!this.smartCaptcha) {
      return;
    }

    return this.smartCaptcha.render(CAPTCHA_CONFIG.containerId, {
      sitekey: CAPTCHA_CONFIG.siteKey,
      invisible: true,
      test: false,
      hideShield: true,
      callback: (token: string) => {
        this.checkCaptcha(token);
        this.destroyCaptcha();
      },
    });
  }

  private destroyCaptcha() {
    this.smartCaptcha.destroy(this.captchaId);
    this.captchaId = undefined;
  }
}
